/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import useExistingClubRegistrationApproval from './UseExistingClubRegistrationApproval';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import ClubRegistrationApprovalForm from '../components/forms/clubRegistrationApprovalForm/ClubRegistrationApprovalForm';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const ExistingClubRegistrationApproval = () => {
  const {
    location,
    Constants,
    isLoading,
    isSaving,
    existingClubRegistrationState,
    clubRegObjState,
    formState,
    errorState,
    onBackClicked,
    onFormValueChanged,
    onApprovedClicked,
    onRequestClicked
  } = useExistingClubRegistrationApproval();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={`Existing Club Registration${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}`}>
        {existingClubRegistrationState.isObjLoaded === true &&
          <form noValidate>
            <ClubRegistrationApprovalForm
              isRevisit={location.state?.isRevisit}
              clubRegObj={clubRegObjState}
              stateObj={existingClubRegistrationState.objData}
              formState={formState}
              errorState={errorState}
              onFormValueChanged={onFormValueChanged} />
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className="col-xs-12">
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onApprovedClicked}>Approve</PrimaryButton>&nbsp;</Fragment>}
                <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onRequestClicked}>Request Additional Info</PrimaryButton>&nbsp;</Fragment>}
              </div>
            </div>
          </form>
        }
      </WorkFlowNavigation>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </div>
  );
};

export default ExistingClubRegistrationApproval;